/**
 * Deep copy of JSON-shaped data (settings, tutorial progress defaults). Used instead of `structuredClone`, which
 * Hermes (React Native) does not provide; for plain JSON data the result is identical.
 */
export const cloneJson = <T>(value: T): T => JSON.parse(JSON.stringify(value)) as T;
